'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _address = require('./address');

var _pager = require('./pager');

var _totals = require('./totals');

var _folderCollapse = require('./folder-collapse');

var _helpQuestion = require('./help-question');

var _contactPerson = require('./contact-person');

var _typeahead = require('./typeahead');

var _gallery = require('./gallery');

var _links = require('./links');

var _datePicker = require('./date-picker');

var _confirmDialog = require('./dialogs/confirm-dialog');

var _unsavedChangesDialog = require('./dialogs/unsaved-changes-dialog');

var _treeView = require('./tree-view');

var _treeViewItem = require('./tree-view-item');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.commoncomponents', []).component('address', _address.addressComponent).component('pager', _pager.pagerComponent).component('totals', _totals.totalsComponent).component('folderCollapse', _folderCollapse.folderCollapseComponent).component('helpQuestion', _helpQuestion.helpQuestionComponent).component('typeahead', _typeahead.typeaheadComponent).component('contactPerson', _contactPerson.contactPersonComponent).component('gallery', _gallery.galleryComponent).component('links', _links.linksComponent).component('fbUnsavedChangesDialog', _unsavedChangesDialog.unsavedChangesDialogComponent).component('fbConfirmDialog', _confirmDialog.confirmDialogComponent).component('fbTreeView', _treeView.treeViewComponent).component('fbTreeViewItem', _treeViewItem.treeViewItemComponent).component('fbDatePicker', _datePicker.febDatePickerComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/common/index.js
// module id = 919
// module chunks = 0